import config from "../../../config.json";
import axios from "axios";



export const handleApiError = (error, context = "") => {
  if (error.response) {
    console.warn(
      `${context} → API responded with status ${error.response.status}`,
      error.response.data
    );
  } else if (error.request) {
    console.error(
      `${context} → No response received from server`,
      error.request
    );
  } else {
    console.error(`${context} → Request setup error`, error.message);
  }
};

export const getVehiclesByOrgIdIndependent = async (organizationId) => {
  try {

    const resp = await axios.get(
      `${config.baseURL}/vehicle/organization/independent/${organizationId}` // Or use ?organizationId=${organizationId}
    );
    return resp.data;
  } catch (error) {
    handleApiError(error, "getVehiclesByOrgId");
    return [];
  }
};

export const getRoutesByOrgIdIndependent = async (organizationId) => {
  try {

    const resp = await axios.get(
      `${config.baseURL}/route/organization/independent/${organizationId}`
    );
    return resp.data;
  } catch (error) {
    handleApiError(error, "getRoutesByOrgId");
    return [];
  }
};

export const getStopsByOrgIdIndependent = async (organizationId) => {
  try {

    const resp = await axios.get(
      `${config.baseURL}/stop/organization/independent/${organizationId}`
    );
    return resp.data;
  } catch (error) {
    handleApiError(error, "getStopsByOrgId");
    return [];
  }
};

export const getOrganizationById = async (organizationId) => {
  try {
    const resp = await axios.get(
      `${config.baseURL}/organization/${organizationId}`
    );
    return resp.data?.organization || null;
  } catch (error) {
    handleApiError(error, "getOrganizationById");
    return null;
  }
};

export const   getStopById = async(id) =>{
  try {

    const response = await axios.get(`${config.baseURL}/stop/id?id=${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch organization locations", error);
  }
};

const stopByCoordsCache = new Map();

export const getStopByCoordinates = async (longitude, latitude, organizationId) => {
  const cacheKey = [
    organizationId,
    Number(latitude).toFixed(5),
    Number(longitude).toFixed(5),
  ].join("_");

  if (stopByCoordsCache.has(cacheKey)) {
    return stopByCoordsCache.get(cacheKey);
  }

  try {
    const resp = await axios.get(`${config.baseURL}/stop/organization/location`, {
      params: { longitude, latitude, organizationId },
    });
    stopByCoordsCache.set(cacheKey, resp.data || null);
    return resp.data;
  } catch (error) {
    handleApiError(error, "getStopByCoordinates");
    stopByCoordsCache.set(cacheKey, null);
    return null;
  }
};

export const getVehicleDirection = async (deviceId) => {
  try {
    const response = await axios.get(
      `${config.baseURL}/vehicle/direction/${deviceId}`,
      {
        withCredentials: true,
      }
    );
    return response.data.direction || "unknown";
  } catch (error) {
    if (error.response && error.response.status === 404) {
      console.info(
        `No cached direction found for deviceId ${deviceId} → returning "unknown"`
      );
      return "unknown"; // fallback instead of null
    }
    handleApiError(error, `getVehicleDirection(${deviceId})`);
    return "unknown";
  }
};

// Adds: fetchInitialLocations - returns a map { [deviceId]: { deviceId, latitude, longitude, speedKph, receivedAt, raw } }
export async function fetchInitialLocations(deviceIds = []) {
  if (!Array.isArray(deviceIds) || deviceIds.length === 0) return {};
  const requests = deviceIds.map(async (deviceId) => {
    try {
      const res = await fetch(`${config.baseURL}/location/latest/${deviceId}`);
      if (!res.ok) return null;
      const data = await res.json();
      if (data && data.latitude != null && data.longitude != null) {
        const lat = Number(data.latitude);
        const lng = Number(data.longitude);
        const speed = Number(data.speed ?? data.Speed ?? null);
        const heading = Number(data.heading ?? data.Heading ?? data.CourseAngle);
        return {
          deviceId,
          latitude: isNaN(lat) ? null : lat,
          longitude: isNaN(lng) ? null : lng,
          speedKph: isNaN(speed) ? null : speed,
          heading: isNaN(heading) ? null : heading,
          receivedAt: new Date().toISOString(),
          raw: data,
        };
      }
    } catch (e) {
      console.warn(`fetchInitialLocations failed for ${deviceId}`, e);
    }
    return null;
  });

  const results = await Promise.all(requests);
  return results.filter(Boolean).reduce((acc, cur) => {
    acc[cur.deviceId] = cur;
    return acc;
  }, {});
}